import type { FaireProductEntity } from "../../entity_types/product";

export const p_l1j942n: FaireProductEntity = {
  token: "p_l1j942n",
  type: "product",
  name: "Craft Ginger Beer",
  brandName: "Spice Route Beverages",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/8214621cb3ab970168b2f23ffad9c39b1dec1d42c8b2bb40239c1e7d7d77a7ae.webp",
  priceDollars: 9.5,
  description: "Spicy ginger beer from Brooklyn",
  categoryTokens: ["cat_food-beverages"],
  tags: ["nyc-local", "premium", "spicy", "brooklyn"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/8214621cb3ab970168b2f23ffad9c39b1dec1d42c8b2bb40239c1e7d7d77a7ae.webp",
  weight: 1.3,
  dimensions: {
    width: 3,
    height: 8,
    depth: 3,
  },
  inStock: true,
};
